var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-cropper',{ref:"cropper",attrs:{"aspect-ratio":360 / 192,"src":_vm.img,"cropImage":_vm.cropImage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }